module.exports = __webpack_public_path__ + "static/img/iconTips.049cf58.png";